

export function ASSERT (condition, message, data = '') {
    if (!condition) {
        console.error('ASSERTION FAILS', message, data);
    }
}